export default __webpack_public_path__ + "static/media/default-user.4255cca7.png";